'use client'

import { CookieBanner } from '@graftcode/design-system'

import { COOKIE_BANNER_GUARD_TEST_IDS } from '@common/common-test-ids.const'

import { useLayoutStore } from '@stores/layout/layout.store'

export function CookieBannerGuard() {
  const { isLoading } = useLayoutStore()

  if (isLoading) return null

  return (
    <div data-testid={COOKIE_BANNER_GUARD_TEST_IDS.root}>
      <CookieBanner />
    </div>
  )
}
